import { Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { HashLink as Link } from "react-router-hash-link";
import { GiPlayButton } from "react-icons/gi";
import { FaAppStoreIos, FaGooglePlay } from "react-icons/fa";
import { useState, useEffect, useRef } from "react";
import "../../node_modules/plyr/dist/plyr.css";
import Plyr from "plyr";
import "plyr/dist/plyr.css";


const MainInfo = ({ showContactUsForm }) => {
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  useEffect(() => {
    if (isVideoOpen) {
      setTimeout(() => {
        new Plyr(`#player_hajjtravel`, {
          youtube: { rel: 0, autoplay: 1 },
        });
      }, 200);
    }
  }, [isVideoOpen]);


  return (
    <section className="bg-white pt-6" id="home">
      <div className="max-w-screen-xl px-4 mx-auto flex lg:flex-row flex-col-reverse lg:grid-cols-12 gap-8">
        <div className="mr-auto place-self-center lg:col-span-7 mt-8">
          <h1 className="max-w-2xl mb-4 text-2xl font-extrabold leading-none tracking-tight md:text-2xl">
            HajjTravel - ваш цифровой партнер в организации Хадж и Умра туров
          </h1>
          <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl">
            Автоматизируйте бронирование, управляйте клиентами и увеличивайте продажи с помощью нашей платформы.
          </p>
          <div className="flex gap-4 lg:flex-row flex-col">
            <Button variant="contained" fullWidth
              to={"#"}
              onClick={showContactUsForm}
            >
              Попробовать 5 дней бесплатно
            </Button>
            <Button clasname="gap-2" variant="outlined" color="primary" fullWidth onClick={() => {
              setIsVideoOpen(true);
            }}>
              <GiPlayButton />
              <span className="ml-2">Посмотреть видео</span>
            </Button>
          </div>
          <div className="flex gap-2 mt-4 pb-4">
            <div className="w-[28px] h-[28px]">
              <a href="https://apps.apple.com/app/id6740137224" target="_blank" rel="noopener noreferrer">
                <img src="/images/app-store.png" alt="appstore" style={{ width: '100%', height: '100%' }} />
              </a>
            </div>
            <div className="w-[28px] h-[28px]">
              <a href="https://play.google.com/store/apps/details?id=com.hajjtravel.mobile" target="_blank" rel="noopener noreferrer">
                <img src="/images/google-play.png" alt="googleplay" style={{ width: '100%', height: '100%' }} />
              </a>
            </div>
          </div>
        </div>
        <div className="lg:mt-0 lg:col-span-5 lg:block lg:w-[600px]">
          <img src="/images/main2.png" alt="mainImg" />
        </div>
      </div>
      <Dialog open={isVideoOpen} onClose={() => setIsVideoOpen(false)} maxWidth="sm" fullWidth>
        <DialogContent sx={{ padding: 0 }}>
          <div id="player_hajjtravel" data-plyr-provider="youtube" data-plyr-embed-id="j47kWf-0xmM"></div>
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default MainInfo;
